// Figtree = mobile banner font, to match the Branding settings preview typography
import '@fontsource/figtree/latin-400.css'
import '@fontsource/figtree/latin-600.css'

import { Box, Image, Stack, Text, VisuallyHidden } from '@mantine/core'

import logoImage from '@/assets/images/Logo-light-punchout.png'
import {
  MOBILE_BANNER_FONT_FAMILY,
  MOBILE_BANNER_SUBTITLE_FONT_SIZE,
  MOBILE_BANNER_SUBTITLE_LETTER_SPACING,
  MOBILE_BANNER_TITLE_FONT_SIZE,
  MOBILE_BANNER_TITLE_LETTER_SPACING,
} from '@/screens/SetupScreen/brandingMobileLayout'
import type { GetChannelPublicInfoResponse } from '@/services/api/api.types'
import * as styles from '@/styles/OnboardingScreen.css'

// Mirrors the BrandBannerPreview capsule from Branding settings.
export function ChannelBrandHeader({
  channel,
  imageUrl,
}: {
  channel: GetChannelPublicInfoResponse
  imageUrl: string | null
}) {
  const title = channel.brandTitle || channel.name
  const hasImage = !!imageUrl

  return (
    <Box
      style={{
        borderRadius: 999,
        padding: 10,
        minHeight: 48,
        width: '100%',
        maxWidth: 420,
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        justifyContent: hasImage ? 'flex-start' : 'center',
        backgroundColor: 'var(--mantine-color-gray-1)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        border: '1px solid var(--mantine-color-gray-2)',
      }}>
      {hasImage && (
        <Box style={{ width: 56, height: 56, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
          <Image src={imageUrl} alt={`${title} logo`} w={56} h={56} fit="cover" />
        </Box>
      )}
      <Stack gap={1} style={{ flex: 1, minWidth: 0 }}>
        <Text
          truncate
          style={{
            fontSize: MOBILE_BANNER_TITLE_FONT_SIZE,
            fontFamily: MOBILE_BANNER_FONT_FAMILY,
            fontWeight: 600,
            letterSpacing: MOBILE_BANNER_TITLE_LETTER_SPACING,
            textTransform: 'uppercase',
            lineHeight: '18px',
            textAlign: hasImage ? 'left' : 'center',
          }}>
          {title}
        </Text>
        {channel.brandSubtitle && (
          <Text
            truncate
            style={{
              fontSize: MOBILE_BANNER_SUBTITLE_FONT_SIZE,
              fontFamily: MOBILE_BANNER_FONT_FAMILY,
              fontWeight: 400,
              letterSpacing: MOBILE_BANNER_SUBTITLE_LETTER_SPACING,
              textTransform: 'uppercase',
              lineHeight: '15px',
              opacity: 0.75,
              textAlign: hasImage ? 'left' : 'center',
            }}>
            {channel.brandSubtitle}
          </Text>
        )}
      </Stack>
    </Box>
  )
}

export function Shell({ children, srHeading }: { children: React.ReactNode; srHeading: string }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <VisuallyHidden component="h1">{srHeading}</VisuallyHidden>
        <header className={styles.header}>
          <img src={logoImage} alt="Sidekick Platform" className={styles.logo} />
        </header>

        <div className={styles.stepperCard}>
          <div className={styles.stepContent}>{children}</div>
        </div>
      </div>
    </div>
  )
}
